import * as React from 'react';
import { useParams } from 'react-router-dom';

import { Lead } from './types';
import { Spinner } from '../assets/Spinner';
import { LeadDetail } from '../component/LeadDetail/LeadDetail';
import { NotFound } from '../component/NotFound';
import { useGetLead } from '../hooks/getLead';
import { useGetLeadTreatments } from '../hooks/getLeadTreatments';

const LeadProfileContent = ({ lead }: { lead: Lead }) => {
  const {
    treatments,
    isLoading: isLoadingTreatments,
    isError: treatmentsIsError,
  } = useGetLeadTreatments(lead.id);

  if (isLoadingTreatments) return <Spinner />;
  if (treatmentsIsError) return <NotFound />;

  return <LeadDetail lead={lead} treatments={treatments} />;
};

export const LeadProfile = () => {
  const { leadId } = useParams<{ leadId: string }>();
  const { lead, isLoading, isError } = useGetLead(leadId ?? '');

  if (isLoading) return <Spinner />;
  if (isError || !lead) return <NotFound />;

  return (
    <div className="h-[calc(100vh-77px)] bg-slate50 p-8">
      <LeadProfileContent lead={lead} />
    </div>
  );
};
